import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, SuccessHttpResponse } from '../../../models/https';
import { ReconciliationHealth } from '../../../models/risk/risk.model';
import useHttps from '../../useHttps';

const useReconciliationHealth = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [health, setHealth] = useState<ReconciliationHealth | null>(null);

  const onError = (err: AxiosError<ErrorHttpResponse>) => {
    console.error(err?.response?.data?.message ?? 'Failed to load reconciliation health');
  };

  const fetchHealth = () => {
    request(
      { url: 'api/v1/admin/reconciliation/health', method: 'get' },
      ({ data }: SuccessHttpResponse<ReconciliationHealth>) => setHealth(data),
      setLoading,
      onError
    );
  };

  return { health, loading, fetchHealth };
};

export default useReconciliationHealth;
